import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import EndUrls from "../../Api/endUrls";
import { getService } from "../../Api/services";

const initialState = {
   trips: [],
   dataList: [],
   lane: [],
   adhocLane: [],
   vehicle: [],
   driver: [],

   tonnage: [],
   dimension: [],
   make: [],
   vehicleCategory: [],
   location: [],
};

// get fleet related dropdown
export const getFleetDropdownAsync = createAsyncThunk(
   "fleet/get-dropdown",
   async ({ err, done } = {}, thunkAPI) => {
      try {
         const response = await getService(EndUrls.getDropdownData, true);
         if (response?.data?.statusCode === 200) {
            console.log("response", response);
            done && done();
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         return thunkAPI.rejectWithValue(error);
      }
   }
);

export const getAllLaneAsync = createAsyncThunk(
   "dropdown/lane",
   async ({ err, done } = {}, thunkAPI) => {
      try {
         const response = await getService(EndUrls.getAllLane, true);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// get all adhoc lanes
export const getAllAdhocLaneAsync = createAsyncThunk(
   "dropdown/adhoc-lane",
   async ({ err, done } = {}, thunkAPI) => {
      try {
         const response = await getService(EndUrls.getAdhocLaneList("2", "3"), true);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         return thunkAPI.rejectWithValue(error);
      }
   }
);

export const getAllDriverAndVehicleAsync = createAsyncThunk(
   "dropdown/vehicle-driver",
   async ({ err, done } = {}, thunkAPI) => {
      try {
         const response = await getService(EndUrls.getDriverDropdownData, true);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.data || response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// get location list
export const locationListAsync = createAsyncThunk(
   "location/list",
   async ({ err, done } = {}, thunkAPI) => {
      try {
         const response = await getService(EndUrls.locationMasterList, true);

         if (response?.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         return thunkAPI.rejectWithValue(error);
      }
   }
);

export const dropdownDataSlice = createSlice({
   name: "dropdown-data",
   initialState,
   reducers: {},
   extraReducers: (builder) => {
      // get fleet dropdown data
      builder.addCase(getFleetDropdownAsync.pending, (state) => {
         state.isLoading = true;
      });
      builder.addCase(getFleetDropdownAsync.fulfilled, (state, action) => {
         console.log("fleet action", action.payload);
         state.isLoading = false;
         state.dimension = action.payload?.dimension || [];
         state.make = action.payload?.make || [];
         state.tonnage = action.payload?.tonnage || [];
         state.vehicleCategory = action.payload?.vehicle_category || [];
         state.location = action.payload?.location_master || [];
      });
      builder.addCase(getFleetDropdownAsync.rejected, (state) => {
         state.isLoading = false;
      });

      // get all lane
      builder.addCase(getAllLaneAsync.pending, (state) => {
         state.isLoading = true;
      });
      builder.addCase(getAllLaneAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         let payloadData = action.payload;
         if (payloadData?.data?.lane) payloadData = payloadData.data.lane;
         else if (payloadData?.lane) payloadData = payloadData.lane;
         
         state.lane = payloadData || [];
      });
      builder.addCase(getAllLaneAsync.rejected, (state) => {
         state.isLoading = false;
      });

      // get all adhoc lane
      builder.addCase(getAllAdhocLaneAsync.pending, (state) => {
         state.isLoading = true;
      });
      builder.addCase(getAllAdhocLaneAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         let payloadData = action.payload;
         if (payloadData?.res) payloadData = payloadData.res;
         else if (payloadData?.data?.lane) payloadData = payloadData.data.lane;
         else if (payloadData?.lane) payloadData = payloadData.lane;
         
         state.adhocLane = payloadData || [];
      });
      builder.addCase(getAllAdhocLaneAsync.rejected, (state) => {
         state.isLoading = false;
      });

      // get all driver & vehicle
      builder.addCase(getAllDriverAndVehicleAsync.pending, (state) => {
         state.isLoading = true;
      });
      builder.addCase(getAllDriverAndVehicleAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.vehicle = action.payload?.vehicle || [];
         state.driver = action.payload?.driver || [];
      });
      builder.addCase(getAllDriverAndVehicleAsync.rejected, (state) => {
         state.isLoading = false;
      });

      // get location list
      builder.addCase(locationListAsync.pending, (state) => {
         state.isLoading = true;
      });
      builder.addCase(locationListAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.location = action.payload || [];
      });
      builder.addCase(locationListAsync.rejected, (state) => {
         state.isLoading = false;
      });
   },
});

export const {} = dropdownDataSlice.actions;

const dropdownDataReducer = dropdownDataSlice.reducer;

export default dropdownDataReducer;
